export enum RtoNationalSidingTypeKey {
  Aluminum = 'aluminum',
  Fiberglass = 'fiberglass',
  Steel = 'steel',
  Vinyl = 'vinyl',
  OtherWood = 'other-wood',
  T1_11 = 't1-11',
  LpSmartSide = 'lp-smartside',
  GpPlytanium = 'gp-plytanium',
  Duratemp = 'duratemp',
  Stucco = 'stucco',
}
